import React from "react";
import SkeletonLoader from "../../../UI/SkeletonLoader";

function StatComponent({ stats, title }) {
  let currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  let formatCurrency = (num) => {
    return currencyFormatter.format(num).replace(".00", "");
  };

  // Debug: Log the stats data to see what's available
  console.log("[StatComponent] Stats data:", {
    hasStats: !!stats,
    hasStatsStats: !!(stats && stats.Stats),
    statsKeys: stats?.Stats ? Object.keys(stats.Stats) : [],
    amountCredits: stats?.Stats?.AmountCredits,
    amountRefunds: stats?.Stats?.AmountRefunds,
  });

  return (
    <>
      {(!stats || !stats.Stats) && (
        <div className="skeleton-grid">
          <SkeletonLoader type="card" count={4} />
          <SkeletonLoader type="card" count={3} />
        </div>
      )}
      {stats && stats.Stats && (
        <>
          <div className="container sales">
            <div className="card positive">
              <p className="numbers">
                #
                {+stats.Stats.CountNewSales +
                  +stats.Stats.CountReactivations +
                  +stats.Stats.CountReferrals}{" "}
                |{" "}
                {formatCurrency(
                  +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals
                )}
              </p>
              <span className="title">FrontEnd</span>
              <span className="subtitle">
                (New Sales + Reactivations + Referrals)
              </span>
            </div>
            <div className="card positive">
              <p className="numbers">
                #{+stats.Stats.CountUpsell + +stats.Stats.CountAdditional} |{" "}
                {formatCurrency(
                  +stats.Stats.AmountUpsell + +stats.Stats.AmountAdditional
                )}
              </p>
              <span className="title">BackEnd</span>
              <span className="subtitle">(Upsells and Additional Offices)</span>
            </div>
            <div className="card positive">
              <p className="numbers">
                #{stats.Stats.CountOneOffs} |{" "}
                {formatCurrency(stats.Stats.AmountOneOffs)}
              </p>
              <span className="title">One Off</span>
              <span className="subtitle">(Accelerators + Add-Ons)</span>
            </div>
            <div className="card positive">
              <p className="totals sales">
                {formatCurrency(
                  +stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals
                )}
              </p>
              <span className="title">Total MRR</span>
              <span className="subtitle">(Backend + Frontend + Referrals)</span>
              <p className="revenue">
                {formatCurrency(
                  +stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals +
                    stats.Stats.AmountOneOffs
                )}
              </p>
              <span className="title">Total Revenue</span>
            </div>
          </div>
          <div className="extra">
            <div className="card" style={{ width: "100%" }}>
              <p className="numbers">
                {stats.AmountNewSalesPerAE &&
                  Object.entries(stats.AmountNewSalesPerAE)
                    .map((e) => {
                      return e[0] + " = " + formatCurrency(+e[1]) + " - ";
                    })
                    .toString()
                    .replaceAll(",", "")}
              </p>
              <p className="numbers">{" | "}</p>
              <p className="numbers">
                {stats.AmountUpsellPerAE &&
                  Object.entries(stats.AmountUpsellPerAE)
                    .map((e) => {
                      return e[0] + " = " + formatCurrency(+e[1]) + " - ";
                    })
                    .toString()
                    .replaceAll(",", "")}
              </p>
            </div>
          </div>
          <div className="container cancellations">
            <div className="card negative">
              <p className="numbers">
                #{stats.Stats.CountCancellations} |{" "}
                {formatCurrency(stats.Stats.AmountFullCancellations)}
              </p>
              <span className="title"># Full Cancellations</span>
            </div>
            <div className="card negative">
              <p className="numbers">
                #{stats.Stats.AmountCancelledProducts} |{" "}
                {formatCurrency(stats.Stats.AmountPartialCancellations)}
              </p>
              <span className="title"># of Cancelled Products</span>
            </div>
            <div className="card negative">
              <p className="totals">
                {formatCurrency(stats.Stats.AmountCancellations)}
              </p>
              <span className="title">Total Lost</span>
            </div>
          </div>

          <div className="container net">
            <div className="card neutral">
              <div
                className="card-content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "80px",
                }}
              >
                <p
                  className="numbers"
                  style={{
                    color: "var(--text-color)",
                    margin: "0.5rem 0",
                    fontSize: "1.5rem",
                    fontWeight: "700",
                  }}
                >
                  {formatCurrency(+stats.Stats.AmountRefunds || 0)}
                </p>
                <span
                  className="title"
                  style={{
                    color: "var(--text-color)",
                    fontSize: "0.875rem",
                    fontWeight: "600",
                  }}
                >
                  Refunds
                </span>
              </div>
            </div>
            <div className="card neutral">
              <div
                className="card-content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "80px",
                }}
              >
                <p
                  className="numbers"
                  style={{
                    color: "var(--text-color)",
                    margin: "0.5rem 0",
                    fontSize: "1.5rem",
                    fontWeight: "700",
                  }}
                >
                  {formatCurrency(+stats.Stats.AmountCredits || 0)}
                </p>
                <span
                  className="title"
                  style={{
                    color: "var(--text-color)",
                    fontSize: "0.875rem",
                    fontWeight: "600",
                  }}
                >
                  Credits
                </span>
              </div>
            </div>
            <div className="card positive">
              <p className="totals">
                {formatCurrency(
                  +stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals -
                    +stats.Stats.AmountCancellations
                )}
              </p>
              <span className="title">NET SALES GROWTH</span>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default StatComponent;
